"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
const castArray = require("./castArray.cjs");
const appendFilters = (objWithFilters = {}, filters) => {
  return {
    ...objWithFilters,
    filters: [...objWithFilters.filters || [], ...castArray.castArray(filters)]
  };
};
exports.appendFilters = appendFilters;
//# sourceMappingURL=appendFilters.cjs.map
